<template>
    <SubLayout
       :pageTitle="title"
       :pageBreadcrumbs="breadcrumbs"
       :hasBack="false"
       :loading="false"
   >
       <template #subHeaderActions>
           <div class="d-flex">
               <Button v-if="$can(abilities.CANCEL_APPOINTMENT)" btn-class="btn-sm me-2 bg-danger text-white" v-show="['SCHEDULED','IN_PROGRESS'].includes(appointment.status)" type="cancel" btn-text="button.cancel" @click="cancelAppointment"/>
               <Button v-if="$can(abilities.UPDATE_APPOINTMENT) || $can(abilities.UPDATE_ALL_APPOINTMENT)" btn-class="btn-sm me-2" v-show="appointment.notes?.length == 0 && appointment.status == 'COMPLETED'" type="new" btn-text="appointments.make_report" @click="reportAppointmentModal"/>
               <Button v-if="$can(abilities.UPDATE_APPOINTMENT) || $can(abilities.UPDATE_ALL_APPOINTMENT)" btn-class="btn-sm me-2" v-show="['SCHEDULED','IN_PROGRESS'].includes(appointment.status)" type="new" btn-text="appointments.report" @click="changeDateAppointmentModal"/>
               <Button icon-class="fas fa-backspace" btn-class="btn-sm" type="cancel" btn-text="crm.back" @click="router.go(-1)"/>
           </div>
       </template>
       <template #layoutContent>
         <Loader :isLoading="isLoading">
           <div class="row d-flex flex-wrap px-5">
               <div class="card mb-5 mt-5">
                   <div class="card-header">
                       <div class="card-title d-flex">
                           <h3 class="text-primary fw-bolder fs-1 me-5">{{ appointment?.title }}</h3>
                           <span :class="'px-5 py-2 badge badge-light-'+getStatusName(appointment.status).color">{{ getStatusName(appointment.status)[locale] }}</span>
                       </div>
                   </div>
                   <div class="card-body">
                       <div class="row">
                           <div class="col-12 col-md-7 col-lg-7">
                              <Information :appointment="appointment" />
                           </div>
                           <div class="col-12 col-md-5 col-lg-5">
                               <Members :appointment="appointment" />
                           </div>
                       </div>
                   </div>
                   <div class="card-footer" >
                       <Report :appointment="appointment" @load="loadAppointment"/>
                   </div>
               </div>
           </div>
         </Loader>
       </template>
   </SubLayout>
   <ReportModal id="reportModal" :appointmentData="appointment" @load="loadAppointment"/>
   <ChangeDateModal id="changeDateModal" :form="formData" @load="loadAppointment"/>
   <AddMembers id="addParticipantModal" :formData="addForm" :appointment="appointment" @load="loadAppointment"/>

</template>

<script setup>
import { ref, watch, computed, onMounted } from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import { useRouter, useRoute } from 'vue-router';
import Loader from "@/components/Loader";
import Button from "@/components/Button";
import {useSwal} from "@/composables/useSwal";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import Information from "./components/Information";
import Members from "./components/Members";
import Report from "./components/Report";
import ReportModal from "@/Modules/CRM/components/Modals/Appointment/ReportModal.vue"
import ChangeDateModal from "@/Modules/CRM/components/Modals/Appointment/ChangeDateModal.vue"
import AddMembers from "@/Modules/CRM/components/Modals/Appointment/AddMembers.vue"
import {useLocales} from "@/composables/locales";
import abilities from "@/composables/abilities";

const {locale} = useLocales()
const store = useStore()
const router = useRouter()
const route = useRoute()

const {showSwal} = useSwal()

const isLoading = ref(false)
const cancel = ref(false)

const title = ref( "menu.crm.appointments")
const breadcrumbs = ref([
 {
   name: 'appointments.list',
   route: 'appointments',
   params: {}
 },
 {
   name: 'appointments.detail',
   route: 'appointments-view',
   params: route.params.id
 }
])

const formData = ref({
   appointment_id: route.params.id,
   start_time: null,
   end_time: null,
   location: '',
   link: '',
})

const appointment = computed(() => store.getters['appointments/currentAppointment'])
const appointmentStatus = computed(() => store.getters['appointments/appointmentStatus'])


watch(() => appointment.value, (newValue) => {
   formData.value.start_time = newValue.start_time
   formData.value.end_time = newValue.end_time
   formData.value.location = newValue.location
   formData.value.link = newValue.link
}, {immediate: true})

const addForm = ref({
   appointment_id: route.params.id,
   users: [],
   contacts: [],
   guest_emails: [],
   sent_email: false
})

function parseCustomDate(dateStr) {
   if(dateStr){
       const [date, time] = dateStr.split(' ');
       const [day, month, year] = date.split('-');
       return new Date(`${year}-${month}-${day}T${time}`);
   }
}

function cancelAppointment(){
   showSwal(
       '',
       i18n.global.t('appointments.swal.cancel')
   ).then( async (result) => {
       if (result.value) {
           try {
               cancel.value = true
               store.dispatch('appointments/cancelAppointment', {appointment_id: route.params.id})
                   .then((response) => {
                       loadAppointment()
                       window.toastr['success'](i18n.global.t('notification.appointment_cancelled'))
                   })
                   .catch(err => {
                   }).finally(() => cancel.value = false)
           }catch (e) {

           }
       }
   });
}

function reportAppointmentModal(){
   $('#reportModal').modal('toggle')
}

function changeDateAppointmentModal(){
   $('#changeDateModal').modal('toggle')
}

function loadAppointment(){
   store.dispatch('appointments/getAppointmentById', route.params.id)
}

function loadData () {
 Promise.all([
   loadAppointment(),
   store.dispatch('appointments/loadAppointmentStatus')
 ])
}

function getStatusName(val){
 const {color, fr, en} = appointmentStatus.value.find(el => el.value === val) || ''
 return {color, fr, en}
}

onMounted(() => {
 loadData()
})
</script>

<style scoped>
   .card-parent {
       position: relative;
   }

   .card-child {
       position: absolute;
       bottom: 0;
       width: 90%;
       font-weight: 500;
       margin-bottom: 20px;
   }
</style>